<style>

.widget{
  display: grid;
  grid-template-columns: 30px auto 30px;
  border-radius: 20px;
  padding: 5px;
  border: 1px white solid;
}
.icon{
  grid-column: 1;
  margin: 2px 0 -2px 2px;
}
.input{
  grid-column: 2;
}
.clear{
  grid-column: 3;
  margin: 2px 0 -2px 2px;
}
.icon-search{
  font-size: 20px;
}
input[type="text"]{
  padding: 0;
  height: auto;
  background-color: inherit;
  border: 0;
  color: white;
}
.icon-clear{
  color: gray;
}
.icon-clear-enabled{
  color: white;
}
</style>

<div class="widget">
  <div class="icon"><i class="icon-search"></i></div>
  <div class="input"><input type="text" bind:value="{value}" placeholder="search" on:keyup="{doSearch}"></div>
  <div class="clear" on:click="{clear}"><i class="icon-clear {value != '' ? 'icon-clear-enabled' : ''}"></i></div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let value = "";

let searchTimeout = null;
function doSearch(e) {
	if (searchTimeout != null) {
		clearTimeout(searchTimeout);
	}
	
	searchTimeout = setTimeout( () => { dispatch("search") }, 450 );
}


function clear() {
  value = "";
  dispatch("search");
}
</script>